exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".consortium-page__title[data-v-4829e32c]{margin-bottom:30px}", ""]);

// exports
